import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import Button from '@mui/material/Button'
import usePageProps from 'hooks/usePageProps'
import sx from './styles'

const ContactOptions = (props) => {
  const {
    displayTitle,
    displaySubtitle = true,
    title = 'VDP_CONTACT_OPTIONS_TITLE',
    showWhatsapp = true,
    // showWhatsapp = true, TODO:Cambiar a true cuando quieran mostrar en todas las secciones
    // showChatWithUs = true,
    showCallUs = true,
    whatsappMessage = '',
    direction = 'row',
    sxProps = {},
    variantPhone = 'shopping', // sales || shopping || checkoutPhone
    variantWhatsappPhone = 'clikauto', // sales-your-car
    containerStyle = {},
    customNumberPhone,
    isQroBranch,
    whatsappButtonId = 'vdp-contact-by-whatsapp',
    phoneButtonId = 'vdp-contact-by-phone',
  } = props
  const { formatMessage: f } = useIntl()
  const {
    salesPhone, shoppingPhone, whatsapp, whatsappVTA, whatsappWelcomeMessage, vtaPhone,
    whatsappQro, vtaPhoneQro,
  } = usePageProps()
  const whatsappMessageFinal = whatsappMessage || whatsappWelcomeMessage
  const checkoutPhone = shoppingPhone
  let phone = isQroBranch ? vtaPhoneQro : shoppingPhone

  if (customNumberPhone) {
    phone = customNumberPhone
  } else if (variantPhone === 'sales') {
    phone = salesPhone
  } else if (variantPhone === 'checkout') {
    phone = checkoutPhone
  } else if (variantPhone === 'vtaPhone') {
    phone = vtaPhone
  }

  const whatsappPhone = variantWhatsappPhone === 'sales-your-car' ? (isQroBranch ? whatsappQro : whatsapp) : whatsappVTA

  const buttons = [
    {
      id: whatsappButtonId,
      text: f({ id: 'CONTACT_OPTION_BUTTON_EASY' }),
      href: `//wa.me/${whatsappPhone}?text=${whatsappMessageFinal}`,
      onClick: null,
      target: '_blank',
      rel: 'noopener noreferrer',
      visible: showWhatsapp,
    },
    {
      id: phoneButtonId,
      text: f({ id: 'CONTACT_OPTION_BUTTON1' }, { phone }),
      href: `tel:${phone}`,
      onClick: null,
      visible: showCallUs,
    },
  ]
  const background = direction === 'column' ? sx.rootColumn : sx.rootRow
  return (
    <Box sx={{ ...background, ...containerStyle }}>
      {displayTitle && (
        <>
          <Typography
            sx={sx.title}
            variant="h2"
            align="center"
          >
            <FormattedMessage id={title} />
          </Typography>

          <Typography
            sx={sx.subtitle}
            variant="body1"
            align="center"
          >
            {displaySubtitle && <FormattedMessage id="VDP_CONTACT_OPTIONS_SUBTITLE" />}
          </Typography>
        </>
      )}

      <Grid
        container
        spacing={1}
        justifyContent="center"
        sx={sx.buttonGrid}
      >
        {buttons.filter((b) => b.visible).map((button) => (
          <Grid
            key={`contact-buttons-${button.text}`}
            size={{
              xs: 12,
              md: direction === 'column' ? 12 : 6,
              lg: direction === 'column' ? 12 : 6,
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              id={button.id}
              href={button.href}
              onClick={button.onClick}
              target={button.target}
              rel={button.rel}
              fullWidth
              component={button.onClick ? 'button' : 'a'}
              sx={sxProps}
              aria-label={button.text}
            >
              {button.text}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default memo(ContactOptions)
